import React, { Component } from 'react';

class IntroSubBlock extends Component {
  render() {
    const { content } = this.props;
    return (
      <div className='middle-navigator-recommendSnippet-right-intro '>
        {content}
      </div>
    );
  }
}

export default IntroSubBlock;
